import { render, staticRenderFns } from "./MaskNumberPopUp.vue?vue&type=template&id=b484a286&"
import script from "./MaskNumberPopUp.vue?vue&type=script&lang=js&"
export * from "./MaskNumberPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MaskNumberPopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports